import { useEffect, useState } from 'react';

// useDebounced liefert den Wert erst, wenn er sich für `delay` ms nicht mehr geändert hat.
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
